import * as z from 'zod';
import { optional, timestampSchema } from './common';

// Restaurant Banner Service + Product Banner Service — the two promo-carousel
// banner shapes. A product banner additionally links a `product_id`.

export const restaurantBannerSchema = z.object({
  id: z.string(),
  restaurant_id: z.string().default(''),
  title: z.string().default(''),
  image: z.string().default(''),
  action_url: z.string().default(''),
  is_active: z.boolean().default(true),
  position: z.number().int().nonnegative().default(0),
  created_at: optional(timestampSchema),
  updated_at: optional(timestampSchema),
});
export type RestaurantBanner = z.infer<typeof restaurantBannerSchema>;

export const productBannerSchema = restaurantBannerSchema.extend({
  product_id: z.string().default(''),
});
export type ProductBanner = z.infer<typeof productBannerSchema>;

/** Single-resource payloads — `data` on the respective `.../{id}` endpoints. */
export const restaurantBannerResponseSchema = z.object({
  banner: restaurantBannerSchema,
});
export const productBannerResponseSchema = z.object({
  banner: productBannerSchema,
});
